import accountImage from '../../assets/images/account-image/1.png';

export default function AccountItem({ account, endIcon, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full px-6 py-2 cursor-pointer border-b-1 border-b-[#CDD9F0] flex items-center space-x-4"
    >
      <div className="flex items-center space-x-4 w-full">
        <div className="min-w-10.5 w-10.5 h-10.5 bg-[#092F7B] rounded-full flex items-center justify-center">
          <img
            src={account.bank_image ? account.bank_image : accountImage}
            alt="Account Image"
            className="w-10.5 h-10.5 min-w-10.5"
          />
          {/* <img
            src="/src/assets/images/banks/usa/pnc_bank.png"
            alt="Account Image"
            className="w-10.5 h-10.5 min-w-10.5 bg-cover rounded-full"
          /> */}
        </div>
        <div className="w-full text-left">
          <p className="text-sm text-[#181D27] font-medium leading-[22px]">
            {account.account_owner_name}
          </p>
          <p className="text-sm text-[#A4A7AE] font-normal leading-[20px]">
            {account.bank_name + ' ' + account.account_number}
          </p>
        </div>
      </div>
      {endIcon}
    </button>
  );
}
